@use "../styles.module.scss" as styles;
@use "/src/styles/mixins.scss";
@use "/src/styles/functions";

.input {
  border: none;
  transition: none;
  width: 100%;
  box-shadow: none;
  outline: none;
  @include styles.appearance-none();
  @include styles.autoTextAlignment();
  background-color: transparent;
  @include mixins.fontType(paragraph-small);
  height: 100%;
  color: functions.getColor(var(--theme-text-strong-900)) !important;

  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    -webkit-text-fill-color: functions.getColor(
      var(--theme-text-soft-400)
    ) !important; // Set text color to white for autofill
    transition: background-color 5000s ease-in-out 0s; // Prevent color flash on autofill
  }

  * {
    color: functions.getColor(var(--theme-text-strong-900)) !important;
  }

  &::placeholder {
    color: functions.getColor(var(--theme-text-soft-400)) !important;
  }
}
